/* 20261105 신규: 디자이너 파일(landing) 경로
   - 개발(IS_FOR_DEV)      : public/landing          → "/landing/"
   - 클라우드(테스트/리얼) : 서버 download 폴더      → "/download/landing/"
   - 로컬 서버             : 클라우드의 download 폴더 → CLOUD_HOST_ADD + "/download/landing/" */
import ConstData from "./ConstData";

const LANDING_DIR_NAME = "landing/";

export const getLandingBaseUrl = () => {
    if (ConstData.IS_FOR_DEV) {
        return "/" + LANDING_DIR_NAME;
    }

    if (ConstData.IS_LOCAL_VERSION) {
        return ConstData.CLOUD_HOST_ADD + ConstData.DOWNLOAD_DIR + LANDING_DIR_NAME;
    }

    return ConstData.DOWNLOAD_DIR + LANDING_DIR_NAME;
};

// 20261105 디자이너 파일이 있는 서버의 origin (iframe 메시지 주고받을 때 출처 확인용)
export const getLandingOrigin = () => {
    try {
        return new URL(getLandingBaseUrl(), window.location.href).origin;
    } catch (err) {
        return window.location.origin;
    }
};

// 20261105 앱을 열 때 한 번 만드는 캐시 회피값 (download 폴더는 캐시 설정이 없어 브라우저가 임의로 캐시할 수 있음)
export const LANDING_CACHE_KEY = String(Date.now());
